import { z } from 'zod';
import { getCookie, removeCookie, setCookie } from './cookie';
import { getSharedCookieDomain } from './get-shared-cookie-domain';
export var LOAN_AMOUNT_COOKIE = 'p24_financing_loan_amount';
// 1h — krótkie okno na przekazanie kwoty z widgetu do aplikacji main.
var LOAN_AMOUNT_COOKIE_MAX_AGE_SECONDS = 60 * 60;
var loanAmountSchema = z.coerce.number().int().positive();
var isSecureContext = function () {
    return typeof window !== 'undefined' && window.location.protocol === 'https:';
};
/**
 * Zapisuje kwotę wybraną na sliderze widgetu do cookie współdzielonego między
 * subdomenami, aby aplikacja main mogła ją odczytać po przejściu z widgetu.
 */
export function persistLoanAmount(amount, panelUrl) {
    setCookie(LOAN_AMOUNT_COOKIE, String(amount), {
        domain: getSharedCookieDomain(panelUrl),
        maxAgeSeconds: LOAN_AMOUNT_COOKIE_MAX_AGE_SECONDS,
        secure: isSecureContext(),
    });
}
/** Odczytuje kwotę przekazaną z widgetu; zwraca undefined gdy brak lub niepoprawna. */
export function readLoanAmount() {
    var parsed = loanAmountSchema.safeParse(getCookie(LOAN_AMOUNT_COOKIE));
    return parsed.success ? parsed.data : undefined;
}
/** Usuwa cookie z kwotą — handoff widget → main jest jednorazowy. */
export function clearLoanAmount(panelUrl) {
    removeCookie(LOAN_AMOUNT_COOKIE, { domain: getSharedCookieDomain(panelUrl) });
}
